import { createRef, Component, ComponentChildren } from "preact";

interface ModalProps {
  children: ComponentChildren;
  buttons?: ComponentChildren;
  title: string;
  dismissHandler?: (hideModal?: () => void) => void;
}

export class MyModal extends Component<ModalProps, {}> {
  ref = createRef<HTMLDivElement>();

  constructor() {
    super();
  }

  componentDidMount() {
    this.ref.current?.style.setProperty('display', 'flex');
    this.ref.current?.addEventListener('click', (e) => {
      if (e.target === this.ref.current) {
        this.props.dismissHandler && this.props.dismissHandler();
      }
    });
  }

  componentWillUnmount() {
    this.hide()
  }

  hide(): void {
    if (this.ref.current) this.ref.current.style.display = 'none';
  }

  render() {
    return <div ref={this.ref} style={{
      display: 'none',
      position: 'fixed',
      top: '0', left: '0', right: '0', bottom: '0',
      background: 'rgba(0,0,0,0.5)',
      zIndex: '10000',
      alignItems: 'center',
      justifyContent: 'center'
    }} tabIndex={-1}>
      <div style={{
        background: '#1e1e2e',
        border: '1px solid #45475a',
        borderRadius: '8px',
        padding: '20px',
        minWidth: '300px',
        maxWidth: '500px',
        color: '#cdd6f4',
        fontFamily: 'inherit'
      }}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
          <h5 style={{margin:0,fontSize:'16px',fontWeight:600}}>{this.props.title}</h5>
          <button onClick={() => this.props.dismissHandler && this.props.dismissHandler()}
            style={{background:'none',border:'none',color:'#6c7086',cursor:'pointer',fontSize:'20px',padding:'0 4px'}}>×</button>
        </div>
        <div style={{marginBottom:'16px'}}>
          {this.props.children}
        </div>
        <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
          {this.props.buttons}
        </div>
      </div>
    </div>;
  }
}

interface ButtonProps {
  priority: "primary" | "secondary" | "danger"
  clickHandler?: () => void
  children: ComponentChildren
  disabled?: boolean;
}

const btnColors: Record<string, {bg: string, hover: string, text: string}> = {
  primary: { bg: '#89b4fa', hover: '#74c7ec', text: '#1e1e2e' },
  secondary: { bg: '#45475a', hover: '#585b70', text: '#cdd6f4' },
  danger: { bg: '#f38ba8', hover: '#eba0ac', text: '#1e1e2e' }
};

export function Button(props:ButtonProps) {
  const c = btnColors[props.priority] || btnColors.secondary;
  return <button type="button" disabled={props.disabled}
    style={{
      padding: '6px 16px',
      borderRadius: '6px',
      border: 'none',
      background: props.disabled ? '#45475a' : c.bg,
      color: props.disabled ? '#6c7086' : c.text,
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      fontSize: '13px',
      fontWeight: 500,
      fontFamily: 'inherit'
    }}
    onClick={ () => { props.clickHandler ? props.clickHandler() : null; }}>{ props.children}</button>
}
